export const 
    INITIAL_STATE = {
        texts: []
    };


// WEBPACK FOOTER //
// ./src/reducers/state/Texts.js